import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery, clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
    loading: false,
    dinamicForms: [],
    open: false,
    create: null,
    update: null,
    assetSubtype: null,
    assetSubtypeId: null
};

const route = "modules/settings/views/AssetSubtype/modals/createEditManageAssetSubtype/redux/slice.";

export const manageAssetSubtypeCreateAssetSubtype = createAsyncThunk("manage/createEditAssetSubtype/createAssetSubtype",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientMutation(
                `
                    mutation createAssetSubtype ($name: String!) {
                        result: createAssetSubtype (name: $name) {
                            id
                            name
                        }
                    }
                `,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.result
        } catch (exc) {
            ExceptionManager(exc, route, "createAssetSubtype");
            return rejectWithValue(exc);
        }
    }
);

export const manageAssetSubtypeEditAssetSubtype = createAsyncThunk("manage/createEditAssetSubtype/updateAssetSubtype",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientMutation(
                `
                    mutation updateAssetSubtype ($id: Int!, $name: String) {
                        result: updateAssetSubtype (id: $id, name: $name) {
                            id
                            name
                        }
                    }
                `,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.result
        } catch (exc) {
            ExceptionManager(exc, route, "updateAssetSubtype");
            return rejectWithValue(exc);
        }
    }
);

export const manageAssetSubtypeGetAssetSubtype = createAsyncThunk("manage/createEditAssetSubtype/getAssetSubtype",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query getAssetSubtype ($id: Int!) {
                        result: getAssetSubtype (id: $id) {
                            id
                            name
                        }
                    }
                `,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );
            return response?.result || null;
        } catch (exc) {
            ExceptionManager(exc, route, "getAssetSubtype");
            return rejectWithValue(exc);
        }
    }
);

//Slice
const manageCreateEditAssetSubtypeRedux = createSlice({
    name: "manage/createEditAssetSubtype",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalCreateEditAssetSubtype(state, action) {
            state.open = true;
            state.assetSubtypeId = action?.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //manageAssetSubtypeCreateAssetSubtype
        builder.addCase(manageAssetSubtypeCreateAssetSubtype.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(manageAssetSubtypeCreateAssetSubtype.fulfilled, (state, action) => {
            state.loading = false;
            state.create = action.payload;
        });
        builder.addCase(manageAssetSubtypeCreateAssetSubtype.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //manageAssetSubtypeEditAssetSubtype
        builder.addCase(manageAssetSubtypeEditAssetSubtype.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(manageAssetSubtypeEditAssetSubtype.fulfilled, (state, action) => {
            state.loading = false;
            state.update = action.payload;
        });
        builder.addCase(manageAssetSubtypeEditAssetSubtype.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //manageAssetSubtypeGetAssetSubtype
        builder.addCase(manageAssetSubtypeGetAssetSubtype.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(manageAssetSubtypeGetAssetSubtype.fulfilled, (state, action) => {
            state.loading = false;
            state.assetSubtype = action.payload;
        });
        builder.addCase(manageAssetSubtypeGetAssetSubtype.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditAssetSubtypeRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditAssetSubtype } = actions;

// Export the reducer, either as a default or named export
export default reducer;